import { render, staticRenderFns } from "./profileHeader.vue?vue&type=template&id=28f2c5f1&scoped=true&"
import script from "./profileHeader.vue?vue&type=script&lang=js&"
export * from "./profileHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f2c5f1",
  null
  
)

export default component.exports